// extracted by mini-css-extract-plugin
export var modal = "_mn-0";